// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq_faq__TO97F","intro":"Faq_intro__4WsbQ","content":"Faq_content__vt2M2"};